// src/store/slices/subscriptionSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/modules/shared/api/axios";
import Swal from "sweetalert2";
import { ZOHO_APP } from "@/config/zoho";

const ZOHO_OWNER = import.meta.env.VITE_ZOHO_OWNER || "abdullahalshahri";
const ZOHO_SUBSCRIPTION_REPORT = "All_Plans";

// ✅ Fetch all subscription plans (sorted by display_number)
export const fetchAnnouncements = createAsyncThunk(
  "announcements/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/get/announcements");
      const announcements = res.data?.announcements || [];
      return announcements;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);



const announcementSlice = createSlice({
  name: "announcements",
  initialState: {
    announcements: [],
    announcementLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 🟢 Fetch all plans
      .addCase(fetchAnnouncements.pending, (state) => {
        state.announcementLoading = true;
        state.error = null;
      })
      .addCase(fetchAnnouncements.fulfilled, (state, action) => {
        state.announcementLoading = false;
        state.announcements = action.payload;
      })
      .addCase(fetchAnnouncements.rejected, (state, action) => {
        state.announcementLoading = false;
        state.error = action.payload;
      })
  },
});

export default announcementSlice.reducer;
